import { defineMessages, IntlShape } from 'react-intl'
import * as yup from 'yup'

import { INewBusinessClientUserFormValues } from 'features/BusinessClients/types'
import schemaValidations from 'utils/schema'

const firstNameMessages = defineMessages({
  required: {
    id: 'businessClients.users.form.firstName.required',
    defaultMessage: 'First name is required'
  }
})

const lastNameMessages = defineMessages({
  required: {
    id: 'businessClients.users.form.lastName.required',
    defaultMessage: 'Last name is required'
  }
})

const titleMessages = defineMessages({
  required: {
    id: 'businessClients.users.form.title.required',
    defaultMessage: 'Title is required'
  }
})

export const newBusinessClientUserSchema = (intl: IntlShape): yup.SchemaOf<INewBusinessClientUserFormValues> => {
  return yup.object().shape({
    hasAdminRole: yup.boolean().required(),
    businessClient: yup
      .object()
      .shape({
        id: yup.string().required(),
        name: yup.string().required()
      })
      .nullable()
      .required(
        intl.formatMessage({
          id: 'businessClients.users.form.businessClient.required',
          defaultMessage: 'Business client is required'
        })
      ),
    businessSite: yup
      .object()
      .shape({
        id: yup.string().required(),
        name: yup.string().required()
      })
      .nullable(),
    firstName: yup.string().required(intl.formatMessage(firstNameMessages.required)),
    lastName: yup.string().required(intl.formatMessage(lastNameMessages.required)),
    phone: schemaValidations(intl).phoneNumber.required,
    email: schemaValidations(intl).email.required,
    title: yup.string().required(intl.formatMessage(titleMessages.required))
  })
}
